/* eslint-disable camelcase */
import axios from 'axios';

import { useServicerStore } from '../store';

const PropertyService = {
  async createProperty({ formValues, loanId }) {
    const values = {
      ...formValues,
      loan_id: loanId,
      servicer_id: useServicerStore.getState()?.servicerId,
    };

    const response = await axios.post('/property', values);

    return response.data;
  },

  async getProperty({ loanId }) {
    const response = await axios.get(`/property/${loanId}`);

    return response.data;
  },

  async updateProperty({ propertyId, formValues }) {
    const values = {
      ...formValues,
    };

    const response = await axios.put(`/property/${propertyId}`, values);

    return response.data;
  },

  async getPropertyVendors(propertyId) {
    const response = await axios.get(`/property/${propertyId}/property_vendor`);

    return response.data;
  },

  async getUniquePropertyVendors(propertyId) {
    const response = await axios.get(`/property/${propertyId}/property_vendor`);

    const vendors = response.data;

    const seenIds = new Set();

    const uniqueVendors = vendors.filter((vendor) => {
      if (!vendor._vendor || !vendor._vendor.id) {
        return false;
      }

      const { id } = vendor._vendor;
      if (seenIds.has(id)) {
        return false;
      }
      seenIds.add(id);
      return true;
    });

    return uniqueVendors;
  },
};

export default PropertyService;
